import restApiConnection from '@/services/api/providers/Connection'
import vehiclesResponse from '@/types/responses/vehiclesResponse'
import vehicleInfo from '@/types/vehicleInfo'
import RestApiBase from '@/services/models/RestApiBase'
import UserSession from '@/services/models/UserSession'
import { CACHE_TTL_DEFAULT } from '@/config'

type vehiclePerPageResponse = {
  data: vehicleInfo[]
  totalPages: number
}

export default class Vehicle extends RestApiBase {
  public static async all({
    callback = (vehicles: vehicleInfo[]) => vehicles,
    operationOfficeIds,
  }: {
    callback?: Function
    operationOfficeIds?: number[]
  } = {}): Promise<vehiclesResponse> {
    return this.sync('GetVehicles', () => {
      return this.selectAll({ callback, operationOfficeIds })
    })
  }

  public static selectAll = async (args: {
    callback: Function
    operationOfficeIds?: number[]
  }): Promise<vehiclesResponse> => {
    let maxPageCount = 1
    let vehicles: vehicleInfo[] = []

    for (let page = 1; page <= maxPageCount; page++) {
      const res = await Vehicle.getPerPage(page, args.operationOfficeIds)
      const data = res.data
      maxPageCount = res.totalPages

      if (data.length === 0) {
        break
      }

      vehicles = vehicles.concat(data)
      args.callback(data)
    }
    return new Promise((resolve) => {
      resolve({ data: vehicles } as vehiclesResponse)
    })
  }

  public static getPerPage = async (
    page: number,
    operationOfficeIds?: number[]
  ): Promise<vehiclePerPageResponse> => {
    const limitPerPage = 30
    const res = await restApiConnection.get('/vehicles', {
      headers: {
        'Cache-Control': 'max-age=0',
      },
      cache: {
        ttl: CACHE_TTL_DEFAULT,
      },
      params: {
        page: page,
        limit: limitPerPage,
        user_session_id: UserSession.getStoredUserId(),
        operation_office_ids: operationOfficeIds?.join(','),
      },
    })
    return Promise.resolve({
      totalPages: res?.data?.total_pages ?? 1,
      data: res?.data?.vehicles ?? [],
    })
  }
}
